/**
 * キャメルケースに変換する
 * @param value オブジェクト
 * @returns キャメルケースのオブジェクト
 */
export const convertToCamelCase = (value: unknown): unknown => {
  const convertKey = (key: string) => {
    return key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  };
  return _convertCase(value, convertKey);
};

/**
 * スネークケースに変換する
 * @param value オブジェクト
 * @returns スネークケースのオブジェクト
 */
export const convertToSnakeCase = (value: unknown): unknown => {
  const convertKey = (key: string) => {
    return key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
  };
  return _convertCase(value, convertKey);
};

const _convertCase = (
  value: unknown,
  convertKey: (v: string) => string,
): unknown => {
  if (Array.isArray(value)) {
    return value.map(
      (item) => _convertCase(item, convertKey) as Record<string, unknown>,
    );
  } else if (typeof value === 'object' && value !== null) {
    const snakeCaseValue: Record<string, unknown> = {};
    for (const key in value) {
      const snakeCaseKey = convertKey(key);
      snakeCaseValue[snakeCaseKey] = _convertCase(
        (value as Record<string, unknown>)[key],
        convertKey,
      );
    }
    return snakeCaseValue;
  } else {
    return value;
  }
};

/**
 * 値が等しいか
 * @param value1 値1
 * @param value2 値2
 * @returns 等しければtrue, そうでなければfalse
 */
export const stringEquals = (value1: string, value2: string): boolean => {
  const modifiedValue1 = value1.trim().toLowerCase();
  const modifiedValue2 = value2.trim().toLowerCase();
  return modifiedValue1.indexOf(modifiedValue2) > -1;
};

/** 表示名を日本語・数字の昇順で比較する。 */
export const compareDisplayNames = (
  value1?: string,
  value2?: string,
): number => (value1 || '').localeCompare(value2 || '', 'ja', { numeric: true });
